module.exports = __webpack_public_path__ + "images/standard-active.ee311297853a34968e8410ad689685d9.png";